// extracted by mini-css-extract-plugin
module.exports = {"navCont":"_1F7Lgv7vS5He1O5D_j-AyC","navDotCont":"_1h79yLoAgujQb1q1sFDgb_","navDot":"_2wtHdunzm_9PMjop5KdLeV","selected":"_2feNVJCj_2_h7tNsLn25wT"};